<template>
  <div class="container-fluid">
    <transition name="slide-fade">
    <div class="search-wrapper" v-if="isSearch">
      <div class="search">
        <search :selected="getStreams.map(item => item.SYS_GUID)" @select="setStream($event)"></search>
      </div>
    </div>
    </transition>
    <div class="row" v-if="!loading">
      <b-sidebar
        id="sidebar-backdrop"
        title=""
        backdrop-variant="dark"
        backdrop
        shadow
        v-model="open"
        width="50%"
        bg-variant="dark"
        text-variant="light"
        no-close-on-backdrop
        class="p-2"
        lazy
      >
        <violation :index="current" @submit="open = false"></violation>
      </b-sidebar>
      <div class="col-md-6" v-if="open"></div>
      <div :class="{ 'col-md-6 hide-panels' : open, 'col-md-12' : !open }">
        <template v-if="!canSwitchStream">
          <div class="overflow-hidden position-relative d-flex pb-3" id="list">
            <div class="row flex-shrink-0 flex-grow-0 container-fluid mx-0 px-0" v-for="(chunk, i) in chunkedStreams" :key="i">
              <div class="col-md-6 stream-wrapper" v-for="(stream, index) in chunk" :key="index+i">
                <stream :html-id="'video'+i+index" :index="index" :stream="stream"  :violation="canSubmitViolation" :change="canSwitchStream" :control="canControlStream" @clear="clearStream($event)" @violation="toggleForm($event)"></stream>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-md-6 stream-wrapper" v-for="(stream, index) in getStreams" :key="index">
              <stream :html-id="'video'+index" :index="index" :stream="stream"  :violation="canSubmitViolation" :change="canSwitchStream" :control="canControlStream" @clear="clearStream($event)" @violation="toggleForm($event)"></stream>
            </div>
          </div>
        </template>

      </div>
    </div>
    <div class="h-100 d-flex justify-content-center align-items-center text-muted" v-else>
      <font-awesome-icon :icon="['fas', 'spinner']" pulse class="fa-3x text-muted"></font-awesome-icon>
    </div>

  </div>
</template>

<script>
  import Vuex from 'vuex'
  import Search from '@/components/Search'
  import Stream from '@/components/Stream'
  import Violation from '@/pages/Violation'
  import { apiQuery } from "../api";
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';
  import _ from 'lodash'

  export default {
    name: "Main",
    components: { Stream, Search, Violation },
    data() {
      return {
        loading: false,
        open: false,
        current: null,
        total: 0,
        items: [],
        sb: null,
        chnk: 0
      }
    },
    async created() {
      if (!this.canOgeOnline && !this.canEgeOnline) {
        if (this.canEgeArchive || this.canOgeArchive)
          this.$router.push({name : 'Archive'})
        if (this.canViewViolations)
          this.$router.push({name : 'List'})
        this.$destroy()
        return false
      }

      if (this.isSearch)
        this.toggleSearch()

      if (!this.canSwitchStream) {
        this.loading = true
        await apiQuery('private', 'data-get-records', {
          table: window.x2.tables.pakview
        }, false).then(res => {
          const paks = res.rows
          this.total = res.count
          return Promise.all(
            paks.map((pak, index) => {
                return Promise.all([
                  apiQuery('private', 'data-get-record', {
                    table: window.x2.tables.schools,
                    recordId: pak.ORG_FK.value
                  }, false),
                  apiQuery('private', 'data-get-record', {
                    table: window.x2.tables.rooms,
                    recordId: pak.CLS_FK.value,
                  }, false)
                ]).then(response => {
                  let room = response.find(item => Object.prototype.hasOwnProperty.call(item,'CLASSROOM'))
                  let org = response.find(item => Object.prototype.hasOwnProperty.call(item,'CODE_OO'))
                  pak['room'] = room
                  pak['org'] = org
                  this.setIndex(index)
                  this.setStream(pak)
                  return Promise.resolve(response)
                })
              })
            ).then(() => {
              this.loading = false;
            setTimeout(() => { this.sb = new PerfectScrollbar('#list', { wheelPropagation: false, suppressScrollY: true, useBothWheelAxes: true }); console.log('scrollbar') }, 500);
            })

        })
      }
    },
    computed: {
      ...Vuex.mapGetters([
        'isSearch',
        'getStreams',
        'userInfo',
        'canOgeOnline',
        'canEgeOnline',
        'canOgeArchive',
        'canEgeArchive',
        'canControlStream',
        'canSwitchStream',
        'canSubmitViolation',
        'canViewViolations',
      ]),
      chunkedStreams() {
        console.log( _.chunk(this.getStreams, 4));
        return  _.chunk(this.getStreams, 4)
      }
    },
    methods: {
      ...Vuex.mapMutations([
        'toggleSearch',
        'setIndex',
        'setStream'
      ]),

      clearStream(i) {
        this.setIndex(i)
        this.setStream({})
        this.$forceUpdate()
      },

      toggleForm(index) {
        this.open = !this.open
        this.current = index
      }
    }
  }
</script>
